<template>
  <b-card
    v-if="!showForm"
    no-body
    class="system-settings-card"
  >
    <!-- START: Action row -->
    <div class="m-2 d-flex justify-content-between table-actions">
      <b-button
        id="create-button"
        variant="primary"
        :class="{
          'icon-disabled': !hasCreateAccess,
        }"
        @click="hasCreateAccess && create()"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-50"
        />
        <span class="align-middle">{{ $t('Create New') }}</span>
      </b-button>
      <b-tooltip target="create-button">
        {{ hasCreateAccess ? $t('Create') : $t('no-action-permission') }}
      </b-tooltip>

      <prozess-search-input
        :value="search"
        :placeholder="$t('Search')"
        @input="handleSearch"
      />
    </div>
    <!-- END: Action row -->
    <!-- START: Table -->
    <div class="m-2">
      <b-table
        ref="refTable"
        :busy="loading"
        :items="items"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('No matching records found')"
        class="table-responsive"
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        @sort-changed="handleSortChange"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
          </div>
        </template>

        <template #head()="{ label }">
          <span style="white-space: nowrap">{{ $t(label) }}</span>
        </template>

        <!-- START: Actions Column -->
        <template #cell(actions)="{ item }">
          <div class="row-flex-align-center row-flex-justify-center">
            <feather-icon
              :id="`edit-row-${item.uuidKey}-preview-icon`"
              icon="EditIcon"
              size="16"
              class="cursor-pointer"
              :class="{
                'icon-disabled': !hasUpdateAccess,
              }"
              @click="hasUpdateAccess && edit(item.uuidKey)"
            />
            <b-tooltip
              placement="left"
              :title="$t('Edit')"
              :target="`edit-row-${item.uuidKey}-preview-icon`"
            />

            <b-tooltip
              placement="left"
              :title="hasUpdateAccess ? $t('Edit') : $t('You dont have permission to update widget')"
              :target="`edit-row-${item.uuidKey}-preview-icon`"
            />
            <feather-icon
              :id="`delete-row-${item.uuidKey}-preview-icon`"
              icon="TrashIcon"
              size="16"
              class="mx-1 cursor-pointer"
              :class="{
                'icon-disabled': !hasDeleteAccess,
              }"
              @click="hasDeleteAccess && handleDelete(item.uuidKey, item.version)"
            />
            <b-tooltip
              placement="left"
              :title="hasDeleteAccess ? $t('Delete') : $t('You dont have permission to remove widget')"
              :target="`delete-row-${item.uuidKey}-preview-icon`"
            />
          </div>
        </template>
        <!-- END: Action Column -->
      </b-table>
    </div>
    <!-- END: Table -->

    <!-- START: Pagination -->
    <prozess-pagination
      v-if="!loading"
      class="mx-2 mb-2"
      :class="{ 'd-none': !total }"
      :meta="dataMeta"
      :page="currentPage"
      :total="total"
      :size="perPage"
      @change="handleCurrentPage"
    />
    <!-- END: Pagination -->
  </b-card>

  <!-- START: Create webhook modal -->
  <widget-form
    v-else
    :id="resourceId"
    :view-only="viewOnly"
    :is-edit-mode="isEditMode"
    @editMode="editDataSource(id)"
  />
  <!-- END: Create webhook modal -->
</template>

<script>
import { dashboardService } from '@/services/dashboard'

import listMixinFactory from '@/mixins/list'
import WidgetForm from '@/views/pages/SystemSettings/DashboardWidgets/Tabs/WidgetForm.vue'
import { title } from '@/@core/utils/filter'
import RootEvents from '@/constants/rootEvents'
import { swalConfirmDeleteOption } from '@/helpers/app'

export default {
  name: 'WidgeList',
  components: { WidgetForm },
  mixins: [
    listMixinFactory({
      routeName: 'dashboard-widget',
      service: dashboardService('widget'),
      tableColumns: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'description', label: 'Description', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'actions', class: 'text-center disabled' },
      ],
      searchField: 'name',
      sort: {
        name: 'name',
        label: 'label',
      },
    }),
  ],

  data: () => ({
    showForm: false,
    viewOnly: false,
    id: null,
    title,
  }),

  watch: {
    showForm(value) {
      if (!value) this.fetchList()
    },
  },

  mounted() {
    this.registerBusEvent(RootEvents.WIDGET_TOGGLE_FORM, ({ showForm }) => {
      this.showForm = showForm
    })

    this.search = ''
  },
  computed: {
    hasCreateAccess() {
        return this.$can('Create', 'Widget')
      },
    hasUpdateAccess() {
        return this.$can('Update', 'Widget')
      },
    hasDeleteAccess() {
        return this.$can('Delete', 'Widget')
      },
  },
  methods: {
    create() {
      this.id = ''
      this.resourceId = null
      this.isEditMode = false
      this.showForm = true
    },

    editDataSource() {
      return 'sadsa'
    },

    handleDelete(id, version) {
      this.$swal(swalConfirmDeleteOption(v => this.$t(v))).then(async result => {
        if (result.value) {
          this.deleteResource(id, version)
        }
      })
    },
  },
}
</script>

<style></style>
